import { render, staticRenderFns } from "./PlayStepList.vue?vue&type=template&id=5a472bfc&scoped=true"
import script from "./PlayStepList.vue?vue&type=script&lang=js"
export * from "./PlayStepList.vue?vue&type=script&lang=js"
import style0 from "./PlayStepList.vue?vue&type=style&index=0&id=5a472bfc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a472bfc",
  null
  
)

export default component.exports